import React from 'react'
import { Modal, Button, Table } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import _ from 'lodash'
import { injectIntl } from 'react-intl'

import { showErrorMessage } from 'services/handleErrors'
import axios from 'axios'
import endpoints from 'services/endpoints'

import style from './style.module.scss'

class AllAncestors extends React.Component {
  state = {
    ancestors: [],
    visible: false,
    hasContacts: false
  }

  componentDidMount() {
    this.getAncestors()
  }

  getAncestors = () => {
    axios.post(endpoints.getAncestors)
    .then(res => {
      const hasContacts = !!_.get(res, 'data.users[0].email', false) || !!_.get(res, 'data.users[0].phone', false)

      this.setState({ ancestors: _.get(res, 'data.users', []), hasContacts })
    })
    .catch((err) => {
      showErrorMessage(err)
    })

  }

  resetState = () => this.setState({ ...this.initState })

  onShow = () => this.setState({ visible: true })

  onClose = () => this.setState({ visible: false })

  render() {
    const ancestorsList = this.state.ancestors.map((ancestor, i) => {
      ancestor.key = ancestor.id;
      ancestor.level = i + 1;

      return ancestor;
    })

    const { formatMessage } = this.props.intl;

    const columns = [
      {
        title: formatMessage({ id: 'page.dashboard.ancestors.modal.table.level' }),
        dataIndex: 'level',
        key: 'level'
      },
      {
        title: formatMessage({ id: 'page.dashboard.ancestors.modal.table.login' }),
        dataIndex: 'login',
        key: 'login'
      },
      {
        title: formatMessage({ id: 'page.dashboard.ancestors.modal.table.name' }),
        dataIndex: 'firstname',
        key: 'firstname',
        render: (firstname, ancestor) => `${ancestor.firstname} ${ancestor.lastname}`
      }
    ]

    if (this.state.hasContacts) {
      columns.push({
        className: style.contacts,
        title: formatMessage({ id: 'page.dashboard.ancestors.modal.table.contacts' }),
        key: 'contacts',
        render: (contacts, { phone, email }) => (
          <>
            {phone && <a href={`phone:${phone}`}>{phone}</a>}
            {email && <a href={`email:${email}`}>{email}</a>}
          </>
        )
      })
    }

    return (
      <>
        <Button
          onClick={this.onShow}
          className={style.showMore}
          icon={<PlusOutlined />}
        >
          {formatMessage({ id: 'page.dashboard.ancestors.showAll' })}
        </Button>
        <Modal
          className={style.modal}
          title={formatMessage({ id: 'page.dashboard.ancestors.all' })}
          visible={this.state.visible}
          footer={null}
          onCancel={this.onClose}
          afterClose={this.resetState}
        >
          <Table
            loading={this.state.loading}
            columns={columns}
            dataSource={ancestorsList}
            pagination={false}
          />
        </Modal>
      </>
    )
  }
}

export default injectIntl(AllAncestors)
